import {
  ElementType,
  isValidElement,
  PropsWithChildren,
  ReactElement,
  useMemo,
  Children
} from "react";
import { findComponentChild } from "../../../tools/components";
import { classNames } from "@ct-react/core";

import "./cta.scss";

type ValidChildren = ReactElement<any, typeof CTAContent>;

type Props = {
  as?: ElementType;
  className?: string;
  children: ValidChildren;
}

export const CTAContent = ({ children }: PropsWithChildren) => children;


const CTA = ({ as: Tag = "div", className, children: propsChildren }: Props) => {

  const wrapperClasses = classNames("wrap", "touch-scroll", className);

  const children = useMemo(() => Children.toArray(propsChildren).filter(isValidElement), [ propsChildren ]);
  const content = useMemo(() => findComponentChild(children, CTAContent), [ children ]);


  return (
    <Tag className={wrapperClasses}>
      <div className="cta">
          {content}
      </div>
    </Tag>);

}

export default CTA;
